import React, { useEffect, createElement } from 'react';
import AdvertorialGlp6TipsF from '../components/AdvertorialGlp6TipsF';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function Glp6TipsFPage() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with Pixel ID
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: '6 Essential Tips for GLP-1 Users',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18388" data-mp="3c6cb0iniy4sp">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18389" data-mp="3c75cp57mm43z">
        <Helmet data-id="element-18390" data-mp="2ogrr9xjjr3id">
          <title data-id="element-18391" data-mp="2og87sce90728">Before You Take Your Next GLP-1 Shot, Read This</title>
          <meta property="og:title" content="Before You Take Your Next GLP-1 Shot, Read This" data-id="element-18392" data-mp="2ji6s81g16pvi" />
          <meta property="og:description" content="After helping thousands of patients navigate GLP-1 medications, here are the critical insights that make all the difference between success and struggle." data-id="element-18393" data-mp="2y6une6lysxkx" />
          <meta property="og:type" content="article" data-id="element-18394" data-mp="25qa56bt7z65z" />
          <meta property="og:url" content={window.location.href} data-id="element-18395" data-mp="25opa8l2ztl7l" />
          <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" data-id="element-18396" data-mp="20qdzm84vj6ob" />
          <meta property="og:image:width" content="1200" data-id="element-18397" data-mp="g83h8hr7dkno" />
          <meta property="og:image:height" content="630" data-id="element-18398" data-mp="l0eefcuk6scj" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18399" data-mp="l1y05iyzhvlp" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18400" data-mp="6d1ozd1ms2gv" />
          <meta name="twitter:title" content="Before You Take Your Next GLP-1 Shot, Read This" data-id="element-18401" data-mp="bbd0rtbhkn1q" />
          <meta name="twitter:description" content="After helping thousands of patients navigate GLP-1 medications, here are the critical insights that make all the difference between success and struggle." data-id="element-18402" data-mp="z0xo0oeoa6gt" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18403" data-mp="pyfzu4fgj3r6" />
          <meta name="twitter:image" content="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" data-id="element-18404" data-mp="u09vfyasphkh" />
        </Helmet>
        <AdvertorialGlp6TipsF data-id="element-18405" data-mp="3ao5cqbwlofh8" />
      </div>
    </HelmetProvider>;
}